import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { LOCALE_NAMESPACE } from '../../../const/translations/LOCALE_NAMESPACE';

import styles from './SubscriptionDetailsMissedUsage.module.scss';

const MISSED_USAGES_PERIOD_UNIT = 'weeks';

const T_PREFIX = 'sold.details.missedUsages';

const SubscriptionDetailsMissedUsage = (props) => {
    const {
        usage,
        group,
    } = props;

    const {
        used,
        end_date: endDate,
        max_usages: maxUsages,
    } = usage;
    const {
        services,
        use_missed_usages_after: useMissedUsagesAfter,
    } = group ?? {};

    const { t } = useTranslation(LOCALE_NAMESPACE.SUBSCRIPTIONS);

    return (
        <div className={styles.missedUsage}>
            <ul className={styles.servicesList}>
                {services?.map((s) => (
                    <li
                        key={s.id}
                        className={styles.service}
                    >
                        <strong
                            title={s.name}
                            className={styles.serviceName}
                        >
                            {s.name}
                        </strong>
                    </li>
                ))}
            </ul>
            <div className={styles.missedUsageInfo}>
                <span className={styles.dash}>
                    —
                </span>
                <div className={styles.info}>
                    <span>
                        {t(`${T_PREFIX}.usagesLeft`, {
                            count: maxUsages - used,
                        })}
                    </span>
                    <span>
                        {t(`${T_PREFIX}.useBefore`, {
                            date: moment.unix(endDate)
                                .add(useMissedUsagesAfter, MISSED_USAGES_PERIOD_UNIT)
                                .add(1, 'day')
                                .startOf('day')
                                .format('DD/MM/YY'),
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

SubscriptionDetailsMissedUsage.propTypes = {
    usage: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
};

SubscriptionDetailsMissedUsage.defaultProps = {};

export default SubscriptionDetailsMissedUsage;
